'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resolver = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _AccountsService = require('../eth/AccountsService');

var _AccountsService2 = _interopRequireDefault(_AccountsService);

var _AllowanceService = require('../eth/AllowanceService');

var _AllowanceService2 = _interopRequireDefault(_AllowanceService);

var _CacheService = require('../utils/CacheService');

var _CacheService2 = _interopRequireDefault(_CacheService);

var _ConsoleLogger = require('../utils/loggers/ConsoleLogger');

var _ConsoleLogger2 = _interopRequireDefault(_ConsoleLogger);

var _DSProxyService = require('../eth/DSProxyService');

var _DSProxyService2 = _interopRequireDefault(_DSProxyService);

var _EthereumCdpService = require('../eth/EthereumCdpService');

var _EthereumCdpService2 = _interopRequireDefault(_EthereumCdpService);

var _EthereumTokenService = require('../eth/EthereumTokenService');

var _EthereumTokenService2 = _interopRequireDefault(_EthereumTokenService);

var _EventService = require('../utils/events/EventService');

var _EventService2 = _interopRequireDefault(_EventService);

var _GasEstimatorService = require('../eth/GasEstimatorService');

var _GasEstimatorService2 = _interopRequireDefault(_GasEstimatorService);

var _NonceService = require('../eth/NonceService');

var _NonceService2 = _interopRequireDefault(_NonceService);

var _NullEventService = require('../utils/events/NullEventService');

var _NullEventService2 = _interopRequireDefault(_NullEventService);

var _NullLogger = require('../utils/loggers/NullLogger');

var _NullLogger2 = _interopRequireDefault(_NullLogger);

var _Eth2DaiDirect = require('../exchanges/oasis/Eth2DaiDirect');

var _Eth2DaiDirect2 = _interopRequireDefault(_Eth2DaiDirect);

var _OasisExchangeService = require('../exchanges/oasis/OasisExchangeService');

var _OasisExchangeService2 = _interopRequireDefault(_OasisExchangeService);

var _PriceService = require('../eth/PriceService');

var _PriceService2 = _interopRequireDefault(_PriceService);

var _ServiceProvider2 = require('./ServiceProvider');

var _ServiceProvider3 = _interopRequireDefault(_ServiceProvider2);

var _SmartContractService = require('../eth/SmartContractService');

var _SmartContractService2 = _interopRequireDefault(_SmartContractService);

var _TimerService = require('../utils/TimerService');

var _TimerService2 = _interopRequireDefault(_TimerService);

var _TokenConversionService = require('../eth/TokenConversionService');

var _TokenConversionService2 = _interopRequireDefault(_TokenConversionService);

var _TransactionManager = require('../eth/TransactionManager');

var _TransactionManager2 = _interopRequireDefault(_TransactionManager);

var _Web3Service = require('../eth/Web3Service');

var _Web3Service2 = _interopRequireDefault(_Web3Service);

var _index = require('./index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resolver = exports.resolver = {
  defaults: {
    accounts: 'AccountsService',
    allowance: 'AllowanceService',
    cache: 'CacheService',
    cdp: 'EthereumCdpService',
    conversion: 'TokenConversionService',
    event: 'EventService',
    // exchange: intentionally omitted
    gasEstimator: 'GasEstimatorService',
    log: 'ConsoleLogger',
    nonce: 'NonceService',
    price: 'PriceService',
    proxy: 'DSProxyService',
    smartContract: 'SmartContractService',
    timer: 'TimerService',
    token: 'EthereumTokenService',
    transactionManager: 'TransactionManager',
    web3: 'Web3Service'
  },
  disabled: {
    event: 'NullEventService',
    log: 'NullLogger'
  }
};

var DefaultServiceProvider = function (_ServiceProvider) {
  (0, _inherits3.default)(DefaultServiceProvider, _ServiceProvider);

  function DefaultServiceProvider() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, DefaultServiceProvider);

    if (config.web3) {
      config = (0, _extends3.default)({}, config, {
        accounts: (0, _extends3.default)({}, config.accounts, {
          web3: (0, _index.getSettings)(config.web3)
        })
      });
    }

    return (0, _possibleConstructorReturn3.default)(this, (DefaultServiceProvider.__proto__ || (0, _getPrototypeOf2.default)(DefaultServiceProvider)).call(this, config, (0, _extends3.default)({
      services: {
        AccountsService: _AccountsService2.default,
        AllowanceService: _AllowanceService2.default,
        CacheService: _CacheService2.default,
        ConsoleLogger: _ConsoleLogger2.default,
        DSProxyService: _DSProxyService2.default,
        Eth2DaiDirect: _Eth2DaiDirect2.default,
        EthereumCdpService: _EthereumCdpService2.default,
        EthereumTokenService: _EthereumTokenService2.default,
        EventService: _EventService2.default,
        GasEstimatorService: _GasEstimatorService2.default,
        NonceService: _NonceService2.default,
        NullEventService: _NullEventService2.default,
        NullLogger: _NullLogger2.default,
        OasisExchangeService: _OasisExchangeService2.default,
        PriceService: _PriceService2.default,
        SmartContractService: _SmartContractService2.default,
        TimerService: _TimerService2.default,
        TokenConversionService: _TokenConversionService2.default,
        TransactionManager: _TransactionManager2.default,
        Web3Service: _Web3Service2.default
      }
    }, resolver)));
  }

  return DefaultServiceProvider;
}(_ServiceProvider3.default);

exports.default = DefaultServiceProvider;